import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { downloadFurtherActionNotice, downloadReferralDate, fetchClosureReasons, submitCloseCase, submitReferCase, submitNoAction  } from "../../lib/everifyStatusApi";


const ReferredPage = () => {
  const [actionType, setActionType] = useState(null); 
  // "REFER" | "CLOSE" | null

  const [referDecision, setReferDecision] = useState(null); 
  // "YES" | "NO" | null

  const [loading, setLoading] = useState(false);

  // Close case flow
  const [closureReasons, setClosureReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [pagePhase, setPagePhase] = useState("decision");


  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleNext = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case selected.");
      return;
    }

    try {
      setLoading(true);

      // REFER FLOW
      if (actionType === "REFER") {
        if (!referDecision) {
          toast.error("Please select Yes or No.");
          return;
        }

        if (referDecision === "YES") {
          await submitReferCase(activeCaseNumber, {
            employee_notified: true,
          });
          setPagePhase("referred");
          toast.success("Case successfully referred.");
          return;
        }

        if (referDecision === "NO") {
          await submitNoAction(activeCaseNumber, {
            employee_notified: true,
          });
          setPagePhase("closed");
          toast.success("No action taken. Case finalized.");
          return;
        }
      }

      // CLOSE CASE FLOW
      if (actionType === "CLOSE") {
        if (!selectedReason) {
          toast.error("Please select a closure reason.");
          return;
        }

        await submitCloseCase(activeCaseNumber, {
          case_closure_reason_code: selectedReason,
        });

        setPagePhase("closed");
        toast.success("Case closed successfully.");
        return;
      }
    } catch {
      toast.error("Action failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // const handleDownloadReferralDate = async () => {
  //   if (!activeCaseNumber) {
  //     toast.error("No active case selected.");
  //     return;
  //   }
  //   try {
  //     await downloadReferralDate(activeCaseNumber);
  //   } catch (error) {
  //     toast.error("Unable to download referral date.");
  //   }
  // };

  const handleDownloadFurtherAction = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case selected.");
      return;
    }
    try {
      await downloadFurtherActionNotice(activeCaseNumber);
    } catch (error) {
      toast.error("Unable to download further action notice.");
    }
  };
  return (
    <StatusLayout
      title="Tentative Non-Confirmation (Mismatch)"
      description="Government records do not match the employee’s information. You must provide the Further Action Notice to the employee"
      showDefaultHome={false}
    >
      <div className="status-section referred-card">
        <h3 className="section-title">NEXT STEPS</h3>

        {/* Download Further Action Notice */}
        {(pagePhase === "decision" || pagePhase === "closed") && (
          <div className="action-row">
            <button
              className="btn-primary-yellow"
              onClick={handleDownloadFurtherAction}
            >
              Download Further Action Notice
            </button>
          </div>
        )}

        {pagePhase === "referred" && (
          <div className="action-row">
            <button
              className="btn-primary-yellow"
              onClick={() => downloadReferralDate(activeCaseNumber)}
            >
              Download Referral Date Confirmation
            </button>
          </div>
        )}

        {/* Decision Section */}
        {pagePhase === "decision" && (
          <div className="decision-section">
            <div className="decision-options">
              {/* OPTION 1: Do you want to refer? */}
              <label className="checkbox-pill">
                <input
                  type="checkbox"
                  checked={actionType === "REFER"}
                  onChange={() => {
                    setActionType("REFER");
                    setReferDecision(null);
                  }}
                />
                <span>Do you want to refer?</span>
              </label>

              {/* OPTION 2: Close Case */}
              <label className="checkbox-pill">
                <input
                  type="checkbox"
                  checked={actionType === "CLOSE"}
                  onChange={async () => {
                    setActionType("CLOSE");
                    setReferDecision(null);
                    try {
                      const reasons = await fetchClosureReasons(activeCaseNumber);
                      setClosureReasons(reasons);
                    } catch {
                      toast.error("Unable to load closure reasons.");
                    }
                  }}
                />
                <span>Close Case</span>
              </label>
            </div>

            {/* Yes / No options */}
            {actionType === "REFER" && (
              <div className="nested-options">
                <label className="checkbox-row">
                  <input
                    type="checkbox"
                    checked={referDecision === "YES"}
                    onChange={() => setReferDecision("YES")}
                  />
                  <span>Yes</span>
                </label>

                <label className="checkbox-row">
                  <input
                    type="checkbox"
                    checked={referDecision === "NO"}
                    onChange={() => setReferDecision("NO")}
                  />
                  <span>No</span>
                </label>
              </div>
            )}

            {/* Closure reasons */}
            {actionType === "CLOSE" && (
              <select
                className="select-dropdown"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                <option value="">Select closure reason</option>
                {closureReasons.map((reason) => (
                  <option
                    key={reason.code || reason.value}
                    value={reason.code || reason.value}
                  >
                    {reason.name || reason.label}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}

        {/* Footer Buttons */}
        <div className="footer-actions">
          <button
            className="btn-secondary-outline"
            onClick={() => navigate("/")}
          >
            Go to Home Page
          </button>

          {pagePhase === "decision" && (
            <button
              className="btn-primary-yellow"
              disabled={
                loading ||
                !actionType ||
                (actionType === "REFER" && !referDecision) ||
                (actionType === "CLOSE" && !selectedReason)
              }
              onClick={handleNext}
            >
              {loading ? "Processing..." : "Submit"}
            </button>
          )}
        </div>
      </div>
    </StatusLayout>
  );
};

export default ReferredPage;
